import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCheck,
  faChevronRight,
  faGamepad,
  faLock,
  faMobileAlt,
  faShieldAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import logo from "assets/img/illustrations/nodra-only-logo.png";
import deletionGuide from "assets/img/echo-trace/account-deletion-guide.png";
import "assets/css/account-deletion.css";

const deletionSteps = [
  "Echo Trace'i açın ve ana menüden Ayarlar'a girin.",
  "Sistem Ayarları ekranının alt kısmına ilerleyin.",
  "Verilerini ve Hesabını Sil seçeneğine dokunun.",
  "Ekrandaki uyarıyı okuyup silme işlemini onaylayın.",
];

const AccountDeletion = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Hesap ve Veri Silme | Echo Trace";
    window.scrollTo(0, 0);
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="deletion-page">
      <nav className="deletion-nav" aria-label="Sayfa navigasyonu">
        <Link className="deletion-brand" to="/" aria-label="Nodra Studios ana sayfa">
          <span><img src={logo} alt="" /></span>
          Nodra Studios
        </Link>
        <Link className="back-link" to="/">
          <FontAwesomeIcon icon={faArrowLeft} /> Ana sayfaya dön
        </Link>
      </nav>

      <header className="deletion-hero">
        <div className="deletion-glow" />
        <div className="deletion-hero-copy">
          <span className="product-label"><i /> ECHO TRACE · HESAP YÖNETİMİ</span>
          <h1>Hesabınız ve verileriniz<br /><em>sizin kontrolünüzde.</em></h1>
          <p>
            Echo Trace hesabınızı ve hesabınızla ilişkili kullanıcı verilerini
            doğrudan oyun içinden kalıcı olarak silebilirsiniz.
          </p>
          <a className="steps-link" href="#silme-adimlari">
            Silme adımlarını görüntüle <FontAwesomeIcon icon={faChevronRight} />
          </a>
        </div>
        <div className="privacy-emblem" aria-hidden="true">
          <span><FontAwesomeIcon icon={faShieldAlt} /></span>
          <i className="emblem-orbit" />
          <i className="emblem-orbit orbit-two" />
        </div>
      </header>

      <section className="trust-strip" aria-label="Hesap silme özellikleri">
        <div><FontAwesomeIcon icon={faMobileAlt} /><span><strong>Uygulama içinden</strong><small>Ek form doldurmadan</small></span></div>
        <div><FontAwesomeIcon icon={faLock} /><span><strong>Güvenli onay</strong><small>İşlem öncesi doğrulama</small></span></div>
        <div><FontAwesomeIcon icon={faTrashAlt} /><span><strong>Kalıcı silme</strong><small>Hesap ve ilişkili veriler</small></span></div>
      </section>

      <section className="deletion-guide" id="silme-adimlari">
        <div className="guide-copy">
          <span className="section-kicker">NASIL YAPILIR?</span>
          <h2>Dört adımda<br />hesabınızı silin.</h2>
          <p className="guide-intro">
            Hesap silme seçeneği oyunun Sistem Ayarları ekranında bulunur.
            İşleme başlamadan önce hesabınıza bağlı doğru profilin açık olduğunu kontrol edin.
          </p>
          <ol className="deletion-steps">
            {deletionSteps.map((step, index) => (
              <li key={step}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <p>{step}</p>
                <FontAwesomeIcon icon={faCheck} />
              </li>
            ))}
          </ol>
        </div>

        <figure className="guide-visual">
          <div className="visual-frame">
            <img
              src={deletionGuide}
              alt="Echo Trace Sistem Ayarları ekranında Verilerini ve Hesabını Sil düğmesinin vurgulanmış görünümü"
            />
          </div>
          <figcaption>
            <span><FontAwesomeIcon icon={faGamepad} /></span>
            Sistem Ayarları ekranının altındaki vurgulanmış seçeneğe dokunun.
          </figcaption>
        </figure>
      </section>

      <section className="deletion-info">
        <article>
          <span className="info-icon"><FontAwesomeIcon icon={faTrashAlt} /></span>
          <div>
            <span className="section-kicker">SİLİNEN VERİLER</span>
            <h2>İşlem neleri kapsar?</h2>
            <p>
              Silme işlemi onaylandığında Echo Trace hesabınız ile bu hesaba bağlı
              profil ve oyun verileri kalıcı silme sürecine alınır. Yasal bir
              zorunluluk nedeniyle tutulması gereken sınırlı kayıtlar, yalnızca
              gerekli süre boyunca korunabilir.
            </p>
          </div>
        </article>
        <aside>
          <strong>İşlem geri alınamaz</strong>
          <p>
            Silme onayından sonra hesabınıza, ilerlemenize ve hesapla ilişkili
            verilere yeniden erişemezsiniz. Devam etmeden önce kararınızı kontrol edin.
          </p>
        </aside>
      </section>

      <section className="support-card">
        <span className="section-kicker">YARDIMA MI İHTİYACINIZ VAR?</span>
        <h2>Yanınızdayız.</h2>
        <p>Hesap veya veri silme sürecinde sorun yaşarsanız bize e-posta ile ulaşabilirsiniz.</p>
        <a href="mailto:info@nodrastudios.com">info@nodrastudios.com</a>
      </section>

      <footer className="deletion-footer">
        <Link className="deletion-brand" to="/"><span><img src={logo} alt="" /></span>Nodra Studios</Link>
        <p>© {new Date().getFullYear()} Nodra Studios. Tüm hakları saklıdır.</p>
        <span>Echo Trace · Hesap ve Veri Silme</span>
      </footer>
    </main>
  );
};

export default AccountDeletion;
